import * as types from './types'
import InvestmentResource from '@/common/resources/investment'

export const actions = {
	getClientInvestmentProducts ({ commit }, userId) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			commit('CLEAR')
			InvestmentResource.getClientInvestmentProducts(userId)
				.then((result) => {
					commit(types.SET_INVESTMENT_PRODUCTS, result.data.investment_products)
					resolve()
				})
				.catch((error) => {
					reject(error)
				})
				.finally(() => {
					commit('LOADER_OUT')
				})
		})
	},
	getInvestmentProduct ({ commit }, id) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			commit('CLEAR')
			InvestmentResource.getInvestmentProduct(id)
				.then((result) => {
					commit(types.SET_INVESTMENT_PRODUCT, result.data.investment_product)
					resolve(result.data.investment_product)
				})
				.catch((error) => {
					reject(error)
				})
				.finally(() => {
					commit('LOADER_OUT')
				})
		})
	},
	setInvestmentProduct ({ commit }, investmentProduct) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			commit('CLEAR')
			InvestmentResource.updateInvestmentProduct(investmentProduct.id, investmentProduct)
				.then((result) => {
					commit(types.SET_INVESTMENT_PRODUCT, result.data.investment_product)
					resolve(result.data.investment_product)
				})
				.catch((error) => {
					reject(error)
				})
				.finally(() => {
					commit('LOADER_OUT')
				})
		})
	},
	addInvestmentProduct ({ commit }, {clientId, investmentProduct}) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			commit('CLEAR')
			InvestmentResource.addInvestmentProduct(clientId, investmentProduct)
				.then((result) => {
					commit(types.ADD_INVESTMENT_PRODUCT, result.data.investment_product)
					resolve(result.data.investment_product)
				})
				.catch((error) => {
					reject(error)
				})
				.finally(() => {
					commit('LOADER_OUT')
				})
		})
	},
	deleteInvestmentProducts ({ commit }, id) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			commit('CLEAR')
			InvestmentResource.deleteInvestmentProducts(id)
				.then((result) => {
					commit(types.DELETE_INVESTMENT_PRODUCT, id)
					resolve()
				})
				.catch((error) => {
					reject(error)
				})
				.finally(() => {
					commit('LOADER_OUT')
				})
		})
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Investment/actions.js